import Logo from 'assets/images/logo.png'
import videoFile from 'assets/videos/banner.mp4'
import videoFile2025 from 'assets/videos/banner2025.mp4'

import styles from './HeaderBanner.module.scss'

import { useVersion } from 'hooks'

const HeaderBanner = () => {
  const { version, isEventPage } = useVersion()

  return (
    <section className={styles.banner}>
      <div className={styles.banner__content}>
        <div className={styles.banner__content__left}>
          <img src={Logo} className={styles.banner__content__left_logo} alt='aws logo' />

          <h1 className={styles.banner__content__left_title}>
            {version === 2026 ? 'Spring 2027' : 'May 24, 2025'}
          </h1>
          <p>Yerevan Armenia </p>
          {!isEventPage && (
            <div>
              <a
                href='https://docs.google.com/forms/d/e/1FAIpQLSdbseOPrKQOSgkIpTANgfy8JXYGMR3A6EytlyXThWMtTjPpvQ/viewform?usp=send_form'
                target='_blanck'
                className={styles.banner__content__left_register}
              >
                Become a Speaker
              </a>
              <a
                target='_blanck'
                href='https://forms.gle/6eb7EhLKp7eZqCok9'
                className={styles.banner__content__left_sponsor}
              >
                Become a Sponsor
              </a>
            </div>
          )}
        </div>
      </div>

      <div className={styles.banner__content__right}>
        <div className={styles.banner__content__right__bg} />
        <video
          loop
          muted
          autoPlay
          playsInline
          className='video-player'
          preload='metadata'
          controlsList='nodownload'
          onError={() => console.error('Error loading video')}
        >
          <source src={version === 2024 ? videoFile : videoFile2025} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  )
}

export default HeaderBanner
